import API from './index';

const api = {
    addMeetingReviewerResult(data) {
        return API.authAPI({
            url: `/arrangement-meeting/add-meeting-arrangement-reviewer-result`,
            method: 'POST',
            data,
        });
    },
    getTypeOfReview({ params }) {
        return API.authAPI({
            url: `/arrangement-meeting/get-type-of-review`,
            method: 'GET',
            params: { ...params },
        });
    },
};

export default api;
